export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker не поддерживается')
    return
  }

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js')
      console.log('[SW] Зарегистрирован:', reg.scope)

      // Слушаем обновления SW — можно показать баннер "Доступно обновление"
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            console.log('[SW] Новая версия доступна — перезагрузи страницу')
            // Здесь можно эмитить событие для показа баннера в UI
          }
        })
      })
    } catch (err) {
      console.error('[SW] Ошибка регистрации:', err)
    }
  })
}